import map from 'mn-utils/map';

const LIFEFLOW_IDS = [
  'need_email_confirmation',
  'need_accept_disclaimer',
  'need_kyc_approve',
  'ready',
  'removing_preparing',
  'removing_wait_pending_operations',
  'removing_withdrawing',
  'removing_finalizing',
  'removed',
  'waiting_onboarding_completion'
];

const LIFEFLOW_NAMES = {
  need_email_confirmation: 'Needs email confirmation',
  need_accept_disclaimer: 'Needs acceptance',
  need_kyc_approve: 'Needs KYC approval',
  ready: 'Ready',
  removing_preparing: 'Preparing for removal',
  removing_wait_pending_operations: 'Awaiting pending operations',
  removing_withdrawing: 'Withdrawing before removal',
  removing_finalizing: 'Finalizing before removal',
  removed: 'Removed',
  waiting_onboarding_completion: 'Waiting for onboarding completion',
};

module.exports = {
  lifeFlowFilter: {
    name: 'lifeflow',
    placeholder: 'Lifeflow status',
    className: 'wAuto (wmin105|wFitContent)>.MuiSelect-root',
    list: map(LIFEFLOW_IDS, (id) => ({
      id,
      name: LIFEFLOW_NAMES[id]
    }))
  },
  lifeFlowNames: LIFEFLOW_NAMES
}
